import { render, staticRenderFns } from "./GameStateModal.vue?vue&type=template&id=6745546f&scoped=true&"
import script from "./GameStateModal.vue?vue&type=script&lang=js&"
export * from "./GameStateModal.vue?vue&type=script&lang=js&"
import style0 from "./GameStateModal.vue?vue&type=style&index=0&id=6745546f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745546f",
  null
  
)

export default component.exports